import React, { useState, useEffect, Fragment } from "react";
import { Link, useHistory } from "react-router-dom";
import {
	API_URL,
	scroll,
	getValFromLS,
	setValToLS,
	ready2Submit,
	createMarkup,
} from "../helpers";
import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Notice from "../components/Notice";
import I from "../components/I";

const CharityRegHome = () => {
	const [names, setNames] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const history = useHistory();

	useEffect(() => {
		scroll();
		init(getValFromLS("crId") || "0");

		// eslint-disable-next-line
	}, []);

	const init = async (id) => {
		const url = new URL(`${API_URL}/crHomeInit`);
		const params = {
			id,
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setNames({ ...json });
				setAlert({});
				window.jQuery(".cycle-slideshow").cycle("stop");
				window.jQuery(".cycle-slideshow").cycle();
			} else if (json && json.resp === 2) {
				// used for closed message
				setAlert({
					type: "error",
					text: json.text,
				});
			} else {
				if (getValFromLS("crId")) {
					setValToLS("crId", "");
				}
				history.push("/registration/info");
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<div id="full-column">
			<Hdg />
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<Fragment>
					<h3>
						<i className="fa fa-pencil-square-o" /> Charity Registration Form
					</h3>
					<div className="notes">
						<p className="bold" style={{ marginTop: "0" }}>
							Please register by Tuesday, September 8 to ensure custom
							pre-printed donor commitment forms.
						</p>

						<p>
							Register by <span className="bold">Friday, October 2</span> to
							make sure your supplies will be ready for the campaign kick-off
							(including standard donor commitment forms).
						</p>

						<p style={{ marginBottom: "0" }}>
							You can register until{" "}
							<span className="bold">February 25, 2027</span> to participate in
							the 2026-2027 campaign fundraiser. Should you have any questions,
							please contact{" "}
							<a href="mailto:stephanie@valerotexasopen.com">
								Stephanie@ValeroTexasOpen.com
							</a>{" "}
							or at 210.345.3839.
						</p>
					</div>

					{names.returning && <Notice returning={names.returning} />}

					<div id="left-column" style={{ padding: "0", marginTop: "0" }}>
						{ready2Submit(names.statuses) ? (
							<p style={{ marginTop: "15px", marginBottom: "15px" }}>
								You have achieved 6 green check marks and can now click on the
								“Submit” button to complete the registration process. If you
								want to review each section once more or make any adjustments,
								please do so before clicking on the “Submit” button. Once you
								submit your registration form, you will receive an email
								confirmation and the ability to download a copy of your
								completed registration.
							</p>
						) : (
							<p style={{ marginTop: "15px", marginBottom: "15px" }}>
								The status will need to include 6 green check marks in order to
								submit completed registration form.
							</p>
						)}

						<table className="approved">
							<thead>
								<tr>
									<th style={{ padding: "10px 5px" }}>Status</th>
									<th className="left" style={{ padding: "10px" }}>
										Section
									</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td style={{ padding: "10px 5px" }}>
										<I status={names.statuses.info} />
									</td>
									<td className="left" style={{ padding: "10px" }}>
										<Link to="/registration/info">Charity Information</Link>
									</td>
								</tr>
								<tr>
									<td style={{ padding: "10px 5px" }}>
										<I status={names.statuses.contact} />
									</td>
									<td className="left" style={{ padding: "10px" }}>
										<Link to="/registration/contact">Contact Information</Link>
									</td>
								</tr>
								<tr>
									<td style={{ padding: "10px 5px" }}>
										<I status={names.statuses.documents} />
									</td>
									<td className="left" style={{ padding: "10px" }}>
										<Link to="/registration/documents">Upload Documents</Link>
									</td>
								</tr>
								<tr>
									<td style={{ padding: "10px 5px" }}>
										<I status={names.statuses.pledge} />
									</td>
									<td className="left" style={{ padding: "10px" }}>
										<Link to="/registration/pledge">
											Donor Commitment Forms
										</Link>
									</td>
								</tr>
								<tr>
									<td style={{ padding: "10px 5px" }}>
										<I status={names.statuses.promote} />
									</td>
									<td className="left" style={{ padding: "10px" }}>
										<Link to="/registration/promote">
											Fundraising Information
										</Link>
									</td>
								</tr>
								<tr>
									<td style={{ padding: "10px 5px" }}>
										<I status={names.statuses.deandi} />
									</td>
									<td className="left" style={{ padding: "10px" }}>
										<Link to="/registration/deandi">PGA TOUR DE&I</Link>
									</td>
								</tr>
								<tr>
									<td style={{ padding: "10px 5px" }}>
										<i
											className={
												ready2Submit(names.statuses)
													? "fa fa-times fa-lg error"
													: "fa fa-times fa-lg invisible"
											}
										/>
									</td>
									<td className="left" style={{ padding: "10px" }}>
										{ready2Submit(names.statuses) ? (
											<div className="homebutton" style={{ marginTop: "0" }}>
												<Link to="/registration/submit">
													<i className="fa fa-share-square-o" /> &nbsp;Submit
													Completed Registration to VTO
													<i className="fa fa-angle-right" />
												</Link>
											</div>
										) : (
											<span className="working">
												Submit Completed Registration to VTO
											</span>
										)}
									</td>
								</tr>
							</tbody>
						</table>

						<div className="spacer" />

						<h4>
							How Champions <span style={{ fontStyle: "italic" }}>fore</span>{" "}
							Charity Works...
						</h4>

						<p>
							Since 1997, the Valero Texas Open has helped hundreds of local
							non-profit charities and schools raise money through a grass-roots
							fundraiser, Champions{" "}
							<span style={{ fontStyle: "italic" }}>fore</span> Charity
							(formerly known as Birdies for Charity); a no-cost program that
							gives 100% of the funds raised back to participating
							organizations.
						</p>

						<p>
							This unique and engaging platform provides donors the ability to
							make a one-time contribution to a participating charity of their
							choice. All contributions can be paid in advance or be billed
							after the tournament. International donations are welcome and all
							donations are 100% tax deductible.
						</p>

						<div className="spacer" />

						<h4>We Help...</h4>

						<ul>
							<li>
								Supply your organization with donor commitment forms &
								fundraising materials
							</li>
							<li>Manage data entry of all donor commitment forms</li>

							<li>
								Provide participating charities a dedicated and customized
								online donation page
							</li>

							<li>Provide donors the option to make their commitment online</li>
							<li>
								Grant access to review real-time fundraising reports online
							</li>
							<li>
								Manage the collections process and mail out tax thank-you
								letters to donors on your behalf
							</li>
							<li>
								Present your organization with a check for 100% of what is
								collected for your organization, as well as incentive funds
								earned
							</li>
						</ul>

						<div className="spacer" />

						<h4>For Charities...</h4>

						<p>
							Valero Texas Open offers a variety of incentive programs for
							participants in Champions{" "}
							<span style={{ fontStyle: "italic" }}>fore</span> Charity
							including a 7% matching gift opportunity.
						</p>

						<div className="spacer" />

						<h4>For Donors...</h4>

						<p>
							We offer great prizes through our “Guess the Champion” contest and
							“Valero’s Fueling The Drive{" "}
							<span style={{ fontStyle: "italic" }}>fore</span> Champions
							Drawing.” Donors have a chance at winning a “Stay and Play”
							package to JW Marriott San Antonio Hill Country Resort and TPC San
							Antonio and Valero gas gift cards.
						</p>
					</div>
					<div
						id="right-column"
						dangerouslySetInnerHTML={createMarkup(names.right)}
						style={{ paddingTop: "3%" }}
					/>
				</Fragment>
			)}
		</div>
	);
};

export default CharityRegHome;
